export enum ServiceAreaType {
  POLYGON = 'POLYGON',
  CIRCLE = 'CIRCLE'
}

export enum ServiceAreaStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED'
}

export const SERVICE_AREA_COLORS = [
  '#6AA6FF',
  '#81B5EB',
  '#5989E9',
  '#7879F1',
  '#09007F',
  '#3E556D',
  '#85B485',
  '#92C72B',
  '#B8AE61',
  '#008081',
  '#297F50',
  '#73FFCD',
  '#7F0000',
  '#FF3B00',
  '#CD5E1B',
  '#FF9A01',
  '#F2B85C',
  '#CBAB80',
  '#B48484',
  '#EC77EB',
  '#CD65CC',
  '#D56587',
  '#7E25DF',
  '#535353'
];
